import { Partial } from '@40seas/entities/common';
import { RutterCompany } from './rutter-company.entity';

export class UpdateRutterCompanyDto extends Partial(RutterCompany) {}
